module.exports = "/fast-coin/fonts/proxima-nova-black.otf";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/fonts/proxima-nova-black.otf
// module id = 2263
// module chunks = 5